(() => {
  const refresh = () => {
    document.querySelectorAll('product-info [data-adya-title-toggle]').forEach((button) => {
      const title = document.getElementById(button.getAttribute('aria-controls'));
      if (!title || !title.getClientRects().length) return;
      const expanded = button.getAttribute('aria-expanded') === 'true';
      if (expanded) title.classList.remove('is-expanded');
      const overflowing = title.scrollHeight > title.clientHeight + 1;
      if (expanded) title.classList.add('is-expanded');
      button.hidden = !overflowing;
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-adya-title-toggle]');
    if (!button) return;
    const title = document.getElementById(button.getAttribute('aria-controls'));
    if (!title) return;
    const expanded = button.getAttribute('aria-expanded') === 'true';
    title.classList.toggle('is-expanded', !expanded);
    button.setAttribute('aria-expanded', String(!expanded));
    button.textContent = expanded ? button.dataset.expand : button.dataset.collapse;
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }
  window.addEventListener('resize', refresh);
  if (document.fonts) document.fonts.ready.then(refresh);
  document.addEventListener('shopify:section:load', refresh);
})();
